import images from "../../ImageVariables";

export const showFileSvg = (addedData: any) => {
  if (addedData.name.toLowerCase().includes(".xlsx")) {
    return images.excel;
  } else if (addedData.name.toLowerCase().includes(".pdf")) {
    return images.PdfDownload;
  } else if (addedData.name.toLowerCase().includes(".doc")) {
    return images.docs;
  } else if (addedData.name.toLowerCase().includes(".docx")) {
    return images.docx;
  } else if (addedData.name.toLowerCase().includes(".png")) {
    return images.png;
  } else if (addedData.name.toLowerCase().includes(".jpeg")) {
    return images.jpeg;
  } else if (addedData.name.toLowerCase().includes(".jpg")) {
    return images.jpg;
  } else {
    return images.file;
  }
};
